// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  BackgroundLayerKind,
} from "./types";

export default {
  layerId: __t.string(),
  name: __t.string(),
  description: __t.string(),
  get kind() {
    return BackgroundLayerKind;
  },
  sourceUrl: __t.string(),
  attribution: __t.string(),
  licenseNote: __t.string(),
  requiresApiKey: __t.bool(),
  defaultEnabled: __t.bool(),
  maxZoom: __t.u32(),
  apiKey: __t.string(),
  dailyRequestCap: __t.u32(),
};
